import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var SourceDtoPriorityInline;
(function (SourceDtoPriorityInline) {
    SourceDtoPriorityInline["HIGH"] = "HIGH";
    SourceDtoPriorityInline["MEDIUM"] = "MEDIUM";
    SourceDtoPriorityInline["LOW"] = "LOW";
})(SourceDtoPriorityInline || (SourceDtoPriorityInline = {}));
export var ContactDtoSourceInline;
(function (ContactDtoSourceInline) {
    ContactDtoSourceInline["ACCOUNT_CONTACT"] = "ACCOUNT_CONTACT";
    ContactDtoSourceInline["AGENCY_CONTACT"] = "AGENCY_CONTACT";
    ContactDtoSourceInline["BROKER_CONTACT"] = "BROKER_CONTACT";
    ContactDtoSourceInline["CAMPAIGN_AGENCY"] = "CAMPAIGN_AGENCY";
    ContactDtoSourceInline["CAMPAIGN_BROKER"] = "CAMPAIGN_BROKER";
    ContactDtoSourceInline["CAMPAIGN_ADVERTISER"] = "CAMPAIGN_ADVERTISER";
})(ContactDtoSourceInline || (ContactDtoSourceInline = {}));
export var LabelType;
(function (LabelType) {
    LabelType["SALESFUNNEL"] = "SALESFUNNEL";
    LabelType["SALESPROMOTION"] = "SALESPROMOTION";
    LabelType["CONTACTS"] = "CONTACTS";
    LabelType["ACCOUNTS"] = "ACCOUNTS";
    LabelType["ORDERS"] = "ORDERS";
    LabelType["PRODUCT"] = "PRODUCT";
    LabelType["WEBSITES"] = "WEBSITES";
})(LabelType || (LabelType = {}));
export var SalesPromotionReportType;
(function (SalesPromotionReportType) {
    SalesPromotionReportType["CONTACT"] = "CONTACT";
    SalesPromotionReportType["ACCOUNT"] = "ACCOUNT";
    SalesPromotionReportType["ORDER"] = "ORDER";
    SalesPromotionReportType["OFFER"] = "OFFER";
})(SalesPromotionReportType || (SalesPromotionReportType = {}));
export var Role;
(function (Role) {
    Role["ADVERTISER"] = "ADVERTISER";
    Role["AGENCY"] = "AGENCY";
    Role["BROKER"] = "BROKER";
    Role["OTHER"] = "OTHER";
    Role["PUBLISHER"] = "PUBLISHER";
})(Role || (Role = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (Gender = {}));
export var OutcomeFilter;
(function (OutcomeFilter) {
    OutcomeFilter["OFFER_NOT_ACCEPTED"] = "OFFER_NOT_ACCEPTED";
    OutcomeFilter["OFFER_ACCEPTED"] = "OFFER_ACCEPTED";
    OutcomeFilter["CONTACTED_CLIENT"] = "CONTACTED_CLIENT";
})(OutcomeFilter || (OutcomeFilter = {}));
export var InvoiceState;
(function (InvoiceState) {
    InvoiceState["OPEN"] = "OPEN";
    InvoiceState["CHARGED"] = "CHARGED";
    InvoiceState["PAID"] = "PAID";
    InvoiceState["CANCELED"] = "CANCELED";
    InvoiceState["HIDDEN"] = "HIDDEN";
    InvoiceState["NONE"] = "NONE";
    InvoiceState["SPLIT"] = "SPLIT";
    InvoiceState["BAD_DEBT"] = "BAD_DEBT";
})(InvoiceState || (InvoiceState = {}));
export var PromotionEmailPlaceholders;
(function (PromotionEmailPlaceholders) {
    PromotionEmailPlaceholders["CONTACT_LAST_NAME"] = "CONTACT_LAST_NAME";
    PromotionEmailPlaceholders["CONTACT_FIRST_NAME"] = "CONTACT_FIRST_NAME";
    PromotionEmailPlaceholders["ACCOUNT_NAME"] = "ACCOUNT_NAME";
})(PromotionEmailPlaceholders || (PromotionEmailPlaceholders = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["NEW"] = "NEW";
    TaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TaskStatus["SNOOZED"] = "SNOOZED";
    TaskStatus["DONE"] = "DONE";
    TaskStatus["ARCHIVED"] = "ARCHIVED";
})(TaskStatus || (TaskStatus = {}));
export var TaskActivityStatusColor;
(function (TaskActivityStatusColor) {
    TaskActivityStatusColor["GREEN"] = "GREEN";
    TaskActivityStatusColor["YELLOW"] = "YELLOW";
    TaskActivityStatusColor["RED"] = "RED";
})(TaskActivityStatusColor || (TaskActivityStatusColor = {}));
export var TaskOutcome;
(function (TaskOutcome) {
    TaskOutcome["NOT_REACHED"] = "NOT_REACHED";
    TaskOutcome["NOT_INTERESTED"] = "NOT_INTERESTED";
    TaskOutcome["OFFER_DENIED"] = "OFFER_DENIED";
    TaskOutcome["INTERESTED_BUT_NO_OFFER"] = "INTERESTED_BUT_NO_OFFER";
    TaskOutcome["OFFER_ACCEPTED"] = "OFFER_ACCEPTED";
    TaskOutcome["SUCCESSFULL_WITHOUT_OFFER"] = "SUCCESSFULL_WITHOUT_OFFER";
    TaskOutcome["OFFER_NOT_ACCEPTED"] = "OFFER_NOT_ACCEPTED";
    TaskOutcome["DUPLICATE"] = "DUPLICATE";
    TaskOutcome["NO_POTENTIAL"] = "NO_POTENTIAL";
    TaskOutcome["AGED"] = "AGED";
    TaskOutcome["NOT_PROCESSED"] = "NOT_PROCESSED";
    TaskOutcome["OTHER"] = "OTHER";
})(TaskOutcome || (TaskOutcome = {}));
export var TaskAdditionalStatus;
(function (TaskAdditionalStatus) {
    TaskAdditionalStatus["NEW"] = "NEW";
    TaskAdditionalStatus["RETURNED_FROM_SNOOZED"] = "RETURNED_FROM_SNOOZED";
    TaskAdditionalStatus["NONE"] = "NONE";
})(TaskAdditionalStatus || (TaskAdditionalStatus = {}));
export var TaskPriority;
(function (TaskPriority) {
    TaskPriority["HIGH"] = "HIGH";
    TaskPriority["MEDIUM"] = "MEDIUM";
    TaskPriority["LOW"] = "LOW";
})(TaskPriority || (TaskPriority = {}));
export var PositionLeadReportType;
(function (PositionLeadReportType) {
    PositionLeadReportType["MAIL"] = "MAIL";
    PositionLeadReportType["STORE"] = "STORE";
})(PositionLeadReportType || (PositionLeadReportType = {}));
export var SalesPromotionStatus;
(function (SalesPromotionStatus) {
    SalesPromotionStatus["ACTIVE"] = "ACTIVE";
    SalesPromotionStatus["INACTIVE"] = "INACTIVE";
    SalesPromotionStatus["CANCELED_STATUS"] = "CANCELED_STATUS";
})(SalesPromotionStatus || (SalesPromotionStatus = {}));
export var SalesPromotionPhase;
(function (SalesPromotionPhase) {
    SalesPromotionPhase["PLANNED"] = "PLANNED";
    SalesPromotionPhase["RUNNING"] = "RUNNING";
    SalesPromotionPhase["FINISHED"] = "FINISHED";
    SalesPromotionPhase["INACTIVE"] = "INACTIVE";
    SalesPromotionPhase["CANCELED"] = "CANCELED";
})(SalesPromotionPhase || (SalesPromotionPhase = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
